import { useState, useEffect } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { addDoc, getDoc } from "firebase/firestore";
import UsuarioDb from "../../../../db/usuarioDb";
import moment, { Moment } from "moment-timezone";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { LoadingButton } from "@mui/lab";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Usuario from "../../../../models/usuario";
import CalculoDb from "../../../../db/calculoDb";
import Calculo from "../../../../models/calculo";
import { SituacaoCalculo } from "../../../../models/enum";
import { Link } from "react-router-dom";
import { iconMapping } from "../../../../stores/snackBarStores";

type Props = {
  open: boolean;
  onClose: () => void;
  usuarioId: string;
};

export default function RefazerCalculosDialog({
  open,
  onClose,
  usuarioId,
}: Props) {
  const [usuario, setUsuario] = useState<Usuario>();
  const [dataInicio, setDataInicio] = useState<Moment>();
  const [salvando, setSalvando] = useState(false);
  const [calculoCriado, setCalculoCriado] = useState(false);
  const dataFim = moment.tz("America/Sao_Paulo").endOf("day");

  useEffect(() => {
    if (!!usuarioId) {
      getDoc(new UsuarioDb().doc({ usuarioId })).then((doc) =>
        setUsuario(doc.data())
      );
    }
  }, [usuarioId]);

  useEffect(() => {
    if (!!usuario?.dataInicio) {
      setDataInicio(usuario.dataInicio.clone());
    }
  }, [usuario]);

  const recalcular = async () => {
    if (!!usuario && !!dataInicio) {
      setSalvando(true);
      addDoc(
        new CalculoDb().collection({ usuarioId: usuario.id, calculoId: "" }),
        new Calculo({
          id: "",
          dataCalculo: moment.tz("America/Sao_Paulo"),
          dataCriacao: moment.tz("America/Sao_Paulo"),
          dataFim: dataFim,
          dataInicio: dataInicio.clone(),
          dataProgresso: dataInicio.clone(),
          situacao: SituacaoCalculo.CALCULANDO,
        })
      )
        .then(() => setCalculoCriado(true))
        .finally(() => setSalvando(false));
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle color="text.primary" sx={{ typography: "h3" }}>
        Recalcular desde{" "}
        <Typography variant="dataMono" fontSize="inherit" fontWeight={500}>
          {dataInicio?.format("DD [de] MMMM [de] YYYY")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {calculoCriado && (
          <Box pb={1}>
            <Alert
              variant="standard"
              severity="success"
              iconMapping={iconMapping}
            >
              Cálculo criado! Acompanhe o andamento na sua{" "}
              <Link to="/timeline">Timeline</Link>.
            </Alert>
          </Box>
        )}
        <Box
          display="flex"
          flexDirection="row"
          my={1}
          justifyContent="space-between"
        >
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Data Início"
              sx={{ width: "18ch" }}
              slotProps={{ textField: { size: "small" } }}
              disableFuture
              minDate={usuario?.dataInicio?.clone() ?? moment()}
              value={dataInicio ?? null}
              onChange={(e: any) => {
                if (e?.isValid()) setDataInicio(e.startOf("day"));
              }}
              disabled={calculoCriado}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Data Fim"
              sx={{ width: "18ch" }}
              slotProps={{ textField: { size: "small" } }}
              disableFuture
              value={dataFim}
              disabled
              onChange={() => {}}
            />
          </LocalizationProvider>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="inherit">
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={salvando}
          disabled={calculoCriado}
          onClick={recalcular}
        >
          Recalcular
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
